export default "__VITE_ASSET__4Q5NXmOk__"